import { render, staticRenderFns } from "./session-progress-bar.vue?vue&type=template&id=2328e4d3&scoped=true&"
import script from "./session-progress-bar.vue?vue&type=script&lang=ts&"
export * from "./session-progress-bar.vue?vue&type=script&lang=ts&"
import style0 from "./session-progress-bar.vue?vue&type=style&index=0&id=2328e4d3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2328e4d3",
  null
  
)

export default component.exports